import { render, staticRenderFns } from "./GisogdDocumentAboutTP.vue?vue&type=template&id=1416fed2&scoped=true&"
import script from "./GisogdDocumentAboutTP.vue?vue&type=script&lang=js&"
export * from "./GisogdDocumentAboutTP.vue?vue&type=script&lang=js&"
import style0 from "./GisogdDocumentAboutTP.vue?vue&type=style&index=0&id=1416fed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1416fed2",
  null
  
)

export default component.exports